<template>
  <div>
    <!-- 新增 修改规则 -->
    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="dialogVisible" width="480px" center>
      <div class="content">
        <!-- 抽查数量 -->
        <div class="row">
          <div class="label">
            {{ $t("message.spotCheckQuantity") }}：
          </div>
          <div class="val">
            <el-radio-group v-model="datas.condition.order_attribute">
              <el-radio :label="item" v-for="(item, index) in rule.condition.order_attribute" :key="index">{{ item
              }}</el-radio>
            </el-radio-group>
          </div>
        </div>
        <!-- 生成条件 -->
        <div class="row">
          <div class="label">
            {{ $t("message.generationCondition") }}：
          </div>
          <div class="val">
            <el-radio-group v-model="datas.condition.amount_type">
              <el-radio :label="item" v-for="(item, index) in rule.condition.amount_type" :key="index">{{ item
              }}</el-radio>
            </el-radio-group>
          </div>
        </div>
        <!-- 是否历史售后 -->
        <div class="row">
          <div class="label" style="width: 100px;">{{ $t("message.historicalAfterSale") }}：</div>
          <div class="val">
            <el-radio-group v-model="datas.condition.has_after_sale">
              <el-radio :label="1">{{ $t("message.are") }}</el-radio>
              <el-radio :label="0">{{ $t("message.no") }}</el-radio>
            </el-radio-group>
          </div>
        </div>
        <!-- 金额 -->
        <div class="row">
          <div class="label">
            {{ $t("message.sum") }}：
          </div>
          <div class="val">
            <div class="val1">
              <el-select v-model="datas.condition.operator">
                <el-option v-for="item in rule.condition.operator" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
            </div>
            <div class="val2">
              <el-input v-model="datas.condition.amount_value" placeholder="请输入正数金额"
                @input="handleInput('')"></el-input>
            </div>
          </div>
        </div>

        <!-- 生成概率 -->
        <div class="row">
          <div class="label">
            {{ $t("message.generationProbability") }}：
          </div>
          <div class="val">
            <div class="val1">
              <el-input v-model="datas.spot_chance" @input="handleInput('spot_chance')">
              </el-input>
              <span>%</span>
            </div>
            <div class="val2">
            </div>
          </div>
        </div>
        <!-- 注意事项 -->
        <div class="row">
          <div class="label">
            {{ $t("message.mattersNeedingAttention") }}：
          </div>
          <div class="val">
            <el-input type="textarea" v-model="datas.remark"></el-input>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="storeRule" v-if="isAdd">
          {{ $t("message.save") }}
        </el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="updateRule" v-else>
          {{ $t("message.save") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

export default {

  data() {
    return {
      isAdd: '',
      title: '',
      dialogVisible: false,
      type: '',
      datas: {
        spot_spark_id: '',
        spot_rate: '',
        spot_chance: '',
        remark: '',
        condition: {
          amount_type: '',
          operator: '',
          amount_value: '',
          order_attribute: '',
          has_after_sale: '',
        },
      },
      rule: {
        condition: {}
      },

    };
  },

  methods: {
    conditionOption(isAdd, type, title) {
      this.isAdd = isAdd
      this.type = type
      this.title = title
      this.$api.spotCheckApi.conditionOption().then(res => {
        this.rule = res.data.find(item => item.types.includes(type - 0))
        this.dialogVisible = true
      })
    },
    // 新增
    storeRule() {
      let flag = this.validationRule()
      if (flag) return this.$message.error('请补全任务生成规则')
      this.$api.spotCheckApi.storeRule(this.datas).then(res => {
        this.$message.success(res.msg)
        this.$parent.$parent.sparkList()
        this.dialogVisible = false
      })
    },
    //修改
    updateRule() {
      let flag = this.validationRule()
      if (flag) return this.$message.error('请补全任务生成规则')
      this.$confirm('是否确认变更当前的任务配置信息，修改后即时生效！', '提示', {
        confirmButtonText: '确认修改',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.$api.spotCheckApi.updateRule(this.datas).then(res => {
          this.$message.success(res.msg)
          this.$parent.$parent.sparkList()
          this.dialogVisible = false
        })

      }).catch(() => {
      });

    },
    // 不能输入负数
    handleInput(type) {
      if (type) { // 最大100%
        this.datas[type] = ("" + this.datas[type]) // 第一步：转成字符串
          .replace(/[^0-9]/g, '') // 第二步：把不是数字过滤
        if (this.datas[type] > 100) {
          this.datas[type] = 100
        }
      } else {
        this.datas.condition.amount_value = ("" + this.datas.condition.amount_value) // 第一步：转成字符串
          .replace(/[^\d^\.]+/g, "") // 第二步：把不是数字，不是小数点的过滤掉
          .replace(/^0+(\d)/, "$1") // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
          .replace(/^\./, "0.") // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
          .match(/^\d*(\.?\d{0,2})/g)[0] || ""; // 第五步：最终匹配得到结果 以数字开头，只有一个小数点，而且小数点后面只能有0到2位小数
        this.$forceUpdate()
      }



    },
    // 验证必填
    validationRule() {
      let flag = false
      for (let key in this.datas) {
        if (this.datas[key] == '' && key != 'remark') {
          flag = true
          return flag
        }
      }
      for (let key in this.datas.condition) {
        if (key === 'has_after_sale') continue
        if (this.datas.condition[key] == '' || this.datas.condition[key] == false) {
          flag = true
          return flag
        }
      }
      return flag
    },

  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;

  .row {
    display: flex;
    margin-bottom: 20px;
    line-height: 40px;

    .label {
      width: 80px;
    }

    .val {
      flex: 1;
      display: flex;
      line-height: 40px;
      align-items: center;

      /deep/.el-textarea__inner {
        height: 150px !important;
        resize: none;
      }

      .val1 {
        flex: 1;
        margin-right: 12px;
        position: relative;

        span {
          position: absolute;
          top: 0;
          line-height: 40px;
          right: 10px;
        }

      }

      .val2 {
        flex: 2;
      }
    }
  }


}
</style>
